import SvgIcon from '@mui/material/SvgIcon';

const GroupedByBookingIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fill: 'none' }} {...props}>
    <path
      d="M20 5H4V7H20V5ZM17 13H8V15H17V13ZM17 9H8V11H17V9ZM6 9H4V11H6V9ZM6 13H4V15H6V13ZM9 17H7V19H9V17ZM20 17H11V19H20V17Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default GroupedByBookingIcon;